import React, { Component } from 'react'

import Input from './Input'

class NumberInput extends Component {
  onChange = (value) => {
    const { onChange } = this.props
    if(onChange) onChange(value)
  }

  render() {
    const {
      value,
      hint
    } = this.props

    return (
      <Input
        type='number'
        hint={hint}
        value={value}
        onChange={this.onChange}
      />
    )
  }
}

export default NumberInput
